export const events = {
  MAP_EXPORT_SNAPSHOT: 'uf.map.export.snapshot',
  MAP_EXPORT_ADVANCED_BUTTON_CLICKED: 'uf.map.export.advanced.opened',
  MAP_EXPORT_ADVANCED_QUEUED: 'uf.map.export.advanced.queued',
};
